import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { combineReducers } from 'redux';

import dashboardEditReducer from '@/features/Dashboard/pages/Edit/model/dashboardEdit.slice';
import { selectionListener } from '@/features/symbol-selector/state/selectionListener';
import symbolSelectorReducer from '@/features/symbol-selector/state/symbolSelector.slice';
import userReducer from '@/shared/store/userSlice';
import authReducer from '@/slices/authSlice';
import tripTokenReducer from '@/slices/tripTokenSlice';
import { permissionListener } from '@/store/permissionListener';

import drawerReducer from './slices/drawerSlice';
import exportReducer from './slices/exportSlice';
import modalReducer from './slices/modalSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  tripToken: tripTokenReducer,
  user: userReducer,
  symbolSelector: symbolSelectorReducer,
  modal: modalReducer,
  drawer: drawerReducer,
  export: exportReducer,
  dashboardEdit: dashboardEditReducer
});

export const store = configureStore({
  // process.env.NODE_ENV === 'development'
  devTools: import.meta.env.DEV,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .prepend(selectionListener.middleware)
      .prepend(permissionListener.middleware),
  reducer: rootReducer
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
